import React, { useCallback, useEffect, useState } from 'react';
import { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getStudentDistribution } from '../../../../../../services/maestro/maestro.service';
import { updateFilter } from '../../../../../../store/actions/filter.actions';

const GroupStudentsContextContext = React.createContext();

export const GroupStudentsContextProvider = ({ children }) => {
  const [curriculumId, setCurriculumId] = useState(null);
  const [currentCurriculum, setCurrentCurriculum] = useState({});

  const [loadingChart, setLoadingChart] = useState(false);
  const [dataChart, setDataChart] = useState([]);
  const dispatch = useDispatch();
  const curriculumList = useSelector((state) => state?.assessment?.curriculum);

  const onCurriculumChange = useCallback((value) => {
    setCurriculumId(value);
    setCurrentCurriculum(curriculumList.find((item) => item._id === value) || {});
    dispatch(updateFilter('groupStudents', {}));
  }, []);

  useEffect(() => {
    if (!curriculumId && curriculumList?.length > 0) {
      onCurriculumChange(curriculumList[0]._id);
    }
  }, [curriculumList]);

  const onLoadStudentDistribution = useCallback(async (curriculumId, filterData = {}) => {
    setLoadingChart(true);
    setDataChart([]);
    try {
      const response = await getStudentDistribution(curriculumId, {
        studentInfo: {
          firstName: filterData.firstName,
          lastName: filterData.lastName,
          preferredName: filterData.preferredName,
          code: filterData.code,
          yearLevelId: filterData.yearLevelId,
          house: filterData.house,
          form: filterData.form,
          flags: filterData.flags
        },
        curriculumInfo: {
          lcElements: filterData.lcElements,
          ulId: ['main'],
          classId: ['main'],
          curriculumElements: filterData.curriculumElements,
          isActived: filterData.isActived
        }
      });
      if (!response.data || response.error) {
        console.error(response.error);
        return;
      } else {
        setDataChart(response.data);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingChart(false);
    }
  }, []);

  return (
    <GroupStudentsContextContext.Provider
      value={{
        curriculumId,
        currentCurriculum,
        onCurriculumChange,

        onLoadStudentDistribution,

        loadingChart,
        dataChart
      }}
    >
      {children}
    </GroupStudentsContextContext.Provider>
  );
};

export const useGroupStudentsContext = () => {
  const context = useContext(GroupStudentsContextContext);
  if (context === undefined) {
    throw new Error('useGroupStudentsContext must be used within a GroupStudentsContextProvider');
  }
  return context;
};
